/**
 * Extracted out of estimateService.js (2026-09-24, 500-line cap: adding the
 * permanent-delete ordering fix pushed that file past the cap). Re-exported
 * from estimateService.js so every existing
 * `from '../../services/estimateService'` import keeps working unchanged.
 *
 * RD-EST-RESP-001 — map `revoke_estimate_response_link`'s raised tokens to i18n
 * keys, mirroring `getRoleRpcErrorKey` (employeeService.js). Returns null for
 * anything unrecognized so the caller falls back to its generic error copy —
 * NEVER echo a raw Postgres message into the UI.
 *
 * The RPC raises exactly three (migration 20260831120000 section 6):
 *   INVALID_ESTIMATE_ID — a null id; a client bug, not a user-facing state, so
 *                         it deliberately has no key and lands on the generic.
 *   MFA_REQUIRED        — caller is a member of THIS tenant but not at AAL2.
 *   NOT_AUTHORIZED      — the merged "unknown id OR foreign tenant OR wrong
 *                         role" token. It is merged ON PURPOSE (round-2 finding
 *                         N3: separate tokens made the RPC an estimate-existence
 *                         oracle) — never split it client-side to "explain"
 *                         which one it was, because the client cannot know.
 */
export function getRevokeResponseLinkErrorKey(errorMessage) {
  const m = typeof errorMessage === 'string' ? errorMessage : '';
  if (m.includes('MFA_REQUIRED')) return 'estimates.rowActions.revokeLinkErrorMfa';
  if (m.includes('NOT_AUTHORIZED')) return 'estimates.rowActions.revokeLinkErrorNotAuthorized';
  return null;
}
